
const checkAnalytics = () => {
  return !!window.analytics
}

const segmentIdentify = (userId, identifyTraits) => {
  if (checkAnalytics()) {
    window.analytics.identify(userId, identifyTraits)
  }
}

const segmentGroup = (groupId, groupTraits) => {
  if (checkAnalytics) {
    window.analytics.group(groupId, groupTraits)
  }
}
const segmentReset = () => {
  if (checkAnalytics && window.analytics) {
    window.analytics.reset()
  }
}

const segmentPage = (to) => {
  if (checkAnalytics()) {
    let pageName = ''
    pageName = to.path
    if (to.params.id) {
      pageName = to.path.replace(`${to.params.id}/`, '')
    }
    if (to.params.token) {
      pageName = to.path.replace(`/${to.params.token}`, '')
    }
    window.analytics.page(pageName)
  }
}

const segmentTrack = (eventName, eventInfo) => {
  if (checkAnalytics) {
    window.analytics.track(eventName, eventInfo)
  }
}

export {
  segmentIdentify,
  segmentGroup,
  segmentReset,
  segmentPage,
  segmentTrack

}
